import { useTranslation } from 'react-i18next'
import { HeroBackdrop } from '#app/components/hero-backdrop.tsx'
import { type Route } from './+types/terms.ts'

export const meta: Route.MetaFunction = () => [
	{
		title: 'AGB | Open Sourced',
	},
	{
		name: 'description',
		content:
			'Allgemeine Geschäftsbedingungen der Open Sourced GmbH, Lostorf, Switzerland.',
	},
]

export default function TermsRoute() {
	const { t } = useTranslation()

	const clauses = t('legal.terms.clauses', {
		returnObjects: true,
	}) as Array<{ title: string; content: string }>

	return (
		<>
			{/* Hero */}
			<section className="relative overflow-hidden pt-32 pb-24">
				<HeroBackdrop />

				<div className="container relative z-10 text-center">
					<h1 className="mx-auto max-w-3xl text-h3 sm:text-h2 md:text-h1 hyphens-manual break-words">
						{t('legal.terms.heading')}
					</h1>
					<p className="mt-4 text-body-md text-muted-foreground">
						{t('legal.terms.lastUpdated')}
					</p>
				</div>
			</section>

			{/* Clauses */}
			<section className="py-24">
				<div className="container max-w-3xl">
					<div className="space-y-10">
						{Array.isArray(clauses) &&
							clauses.map((clause, index) => (
								<article key={index}>
									<h2 className="text-h4 mb-3 break-words">
										{clause.title}
									</h2>
									<p className="text-body-md text-muted-foreground">
										{clause.content}
									</p>
								</article>
							))}
					</div>
				</div>
			</section>
		</>
	)
}
